/* eslint-disable */
import { v4 as uuid } from 'uuid';
import { RiAdvertisementLine, RiCommunityFill, RiCustomerServiceFill, RiUserCommunityFill } from 'react-icons/ri';
import { MdAutoFixHigh, MdBiotech, MdCampaign, MdCancel, MdDashboard, MdEmail, MdGroup, MdLiveHelp, MdOutlineBusiness, MdOutlineMessage, MdOutlineSettings, MdSubscriptions, MdTableView } from 'react-icons/md';
import { CgTemplate } from "react-icons/cg";
import { FaBlog, FaCalendarCheck, FaChartLine, FaFileInvoiceDollar, FaFileSignature, FaTasks, FaUserNinja, FaUserSecret, FaUserShield } from 'react-icons/fa';
import { FaBowlFood, FaClipboardQuestion, FaWeightScale, FaCalendar } from "react-icons/fa6";
import { IoStorefrontOutline } from "react-icons/io5";
import { TbAffiliate, TbAffiliateFilled, TbBrandCampaignmonitor, TbLogs, TbMessage2Code, TbReport } from "react-icons/tb";
import { PiUserRectangleLight } from "react-icons/pi";
import ROUTES from '../constants/routes';
import { hasAdminPermissions, hasAllStaffPermissions, hasHelpStaffPermissions, hasMarketingManagerPermissions, hasOwnerPermissions, hasRepPerformancePermissions, hasRepPermissions, hasStaffManagerPermissions, hasSuperAdminPermissions } from '../utils/permissions';
import { GrAnalytics } from 'react-icons/gr';
import { BiFoodMenu } from 'react-icons/bi';
import { MdMenuBook } from 'react-icons/md';
import { getStaffDashboardLabel } from '../utils/staffDashboardUtils';

const DashboardMenu = (authContext) => {
	// console.log('authContext', authContext);

	return [
		{
			id: uuid(),
			title: getStaffDashboardLabel(authContext),
			icon: <MdDashboard className="nav-icon me-2" />,
			link: ROUTES.ADMIN,
			show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) || hasHelpStaffPermissions(authContext)
		},
		{
			id: uuid(),
			title: 'Finance',
			icon: <FaFileInvoiceDollar className="nav-icon me-2" />,
			show: hasMarketingManagerPermissions(authContext),
			children: [
				{ id: uuid(), name: 'KPI Statistics', icon: <GrAnalytics className="nav-icon me-2" />, link: ROUTES.MANAGE_STATISTICS, show: hasOwnerPermissions(authContext) },
				{ id: uuid(), name: 'Retention Statistics', icon: <GrAnalytics className="nav-icon me-2" />, link: ROUTES.MANAGE_RETENTION_STATISTICS, show: hasStaffManagerPermissions(authContext) },
				{ id: uuid(), name: 'Funnel Statistics', icon: <GrAnalytics className="nav-icon me-2" />, link: ROUTES.MANAGE_FUNNEL_STATISTICS, show: hasMarketingManagerPermissions(authContext) },
				{ id: uuid(), name: 'Sales by State', icon: <FaChartLine className="nav-icon me-2" />, link: ROUTES.MANAGE_SALES_BY_STATE, show: hasOwnerPermissions(authContext) },
				{ id: uuid(), name: 'Financials', icon: <FaFileInvoiceDollar className="nav-icon me-2" />, link: ROUTES.MANAGE_FINANCIALS, show: hasOwnerPermissions(authContext) }
			]
		},
		{
			id: uuid(),
			title: 'Tasks',
			icon: <FaTasks className="nav-icon me-2" />,
			link: ROUTES.MANAGE_TASKS,
			show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
		},
		{
			id: uuid(),
			title: 'Support',
			icon: <MdLiveHelp className="nav-icon me-2" />,
			link: ROUTES.MANAGE_SUPPORT,
			show: hasRepPermissions(authContext)
		},
		{
			id: uuid(),
			title: 'Inbox Oversight',
			icon: <MdOutlineMessage className="nav-icon me-2" />,
			link: ROUTES.MANAGE_SUPPORT_OVERSIGHT,
			show: hasStaffManagerPermissions(authContext) || hasAdminPermissions(authContext) || hasSuperAdminPermissions(authContext)
		},
		{
			id: uuid(),
			title: 'Marketing',
			icon: <TbBrandCampaignmonitor className="nav-icon me-2" />,
			show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext),
			children: [
				{
					id: uuid(),
					title: 'Leads',
					icon: <RiAdvertisementLine className="nav-icon me-2" />,
					children: [
						{ id: uuid(), link: ROUTES.MANAGE_LEADS, name: 'All Leads', show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) },
						{
							id: uuid(),
							divider: true
						},
						{ id: uuid(), link: ROUTES.MANAGE_LEAD_AGGREGATES, name: 'Aggregates', show: hasAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_LEAD_AFFILIATE_AGGREGATES, name: 'Affiliate Aggregates', show: hasAdminPermissions(authContext) },
					]
				},
				{
					id: uuid(),
					name: 'Campaigns',
					icon: <MdCampaign className="nav-icon me-2" />,
					link: ROUTES.MANAGE_CAMPAIGNS,
					show: hasAdminPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Referral Codes',
					link: ROUTES.MANAGE_REFERRAL_CODES,
					show: hasAllStaffPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Send Email Campaign',
					link: ROUTES.MANAGE_EMAIL_CAMPAIGN,
					show: hasAllStaffPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Automations',
					icon: <MdAutoFixHigh className="nav-icon me-2" />,
					link: ROUTES.MANAGE_AUTOMATIONS,
					show: hasSuperAdminPermissions(authContext)
				}
			],
		},
		{
			id: uuid(),
			title: 'Affiliates',
			icon: <TbAffiliate className="nav-icon me-2" />,
			show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext),
			children: [
				{
					id: uuid(),
					name: 'Manage Affiliates',
					icon: <TbAffiliate className="nav-icon me-2" />,
					link: ROUTES.MANAGE_AFFILIATES,
					show: hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					link: ROUTES.MANAGE_AFFILIATE_USERS,
					name: 'Affiliate Users',
					show: hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Conversions',
					icon: <TbAffiliateFilled className="nav-icon me-2" />,
					link: ROUTES.MANAGE_AFFILIATE_CONVERSIONS,
					show: hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Payouts',
					icon: <TbAffiliateFilled className="nav-icon me-2" />,
					link: ROUTES.MANAGE_AFFILIATE_PAYOUTS,
					show: hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Coupon Uses',
					icon: <TbAffiliateFilled className="nav-icon me-2" />,
					link: ROUTES.MANAGE_COUPON_USES,
					show: hasAdminPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Sales & Consult Funnel Insights',
					icon: <GrAnalytics className="nav-icon me-2" />,
					link: ROUTES.MANAGE_ANALYTICS,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
				},
				{ id: uuid(), name: 'Funnel Analytics', icon: <GrAnalytics className="nav-icon me-2" />, link: ROUTES.MANAGE_FUNNEL_ANALYTICS, show: hasMarketingManagerPermissions(authContext) },
				{ id: uuid(), name: 'Site Visits', icon: <GrAnalytics className="nav-icon me-2" />, link: ROUTES.MANAGE_SITE_VISITS, show: hasMarketingManagerPermissions(authContext) },
				{ id: uuid(), name: 'Site Events', icon: <GrAnalytics className="nav-icon me-2" />, link: ROUTES.MANAGE_SITE_EVENTS, show: hasMarketingManagerPermissions(authContext) },
				{ id: uuid(), name: 'Site Event Step Summary', icon: <GrAnalytics className="nav-icon me-2" />, link: ROUTES.MANAGE_SITE_EVENT_STEP_SUMMARY, show: hasMarketingManagerPermissions(authContext) },
				{
					id: uuid(),
					link: ROUTES.MANAGE_COUPONS,
					name: 'Coupons',
					show: hasMarketingManagerPermissions(authContext)
				}]
		},
		{
			id: uuid(),
			title: 'Subscriptions & Orders',
			icon: <MdSubscriptions className="nav-icon me-2" />,
			show: (hasRepPermissions(authContext) || hasHelpStaffPermissions(authContext) || hasMarketingManagerPermissions(authContext)),
			children: [
				{
					id: uuid(),
					name: 'Subscriptions',
					icon: <MdSubscriptions className="nav-icon me-2" />,
					link: ROUTES.MANAGE_SUBSCRIPTIONS,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Cancelled Subscriptions',
					icon: <MdCancel className="nav-icon me-2" />,
					link: ROUTES.MANAGE_CANCELLED_SUBSCRIPTIONS,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Cancellation Requests',
					icon: <MdCancel className="nav-icon me-2" />,
					link: ROUTES.MANAGE_CANCELLATION_REQUESTS,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Orders Overview',
					icon: <FaFileInvoiceDollar className="nav-icon me-2" />,
					link: ROUTES.MANAGE_ORDERS,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Voucher Orders',
					icon: <FaFileInvoiceDollar className="nav-icon me-2" />,
					link: ROUTES.MANAGE_VOUCHER_ORDERS,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Prescription Orders',
					icon: <FaFileInvoiceDollar className="nav-icon me-2" />,
					link: ROUTES.MANAGE_PRESCRIPTION_ORDERS,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Order Groups',
					icon: <FaFileInvoiceDollar className="nav-icon me-2" />,
					link: ROUTES.MANAGE_ORDER_GROUPS,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Prescriptions',
					icon: <FaFileInvoiceDollar className="nav-icon me-2" />,
					link: ROUTES.MANAGE_PRESCRIPTIONS,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Encounters',
					icon: <FaFileInvoiceDollar className="nav-icon me-2" />,
					link: ROUTES.MANAGE_ENCOUNTERS,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Payments',
					icon: <FaFileInvoiceDollar className="nav-icon me-2" />,
					link: ROUTES.MANAGE_PAYMENTS,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Transactions',
					icon: <FaFileInvoiceDollar className="nav-icon me-2" />,
					link: ROUTES.MANAGE_TRANSACTIONS,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Vouchers',
					icon: <FaFileInvoiceDollar className="nav-icon me-2" />,
					link: ROUTES.MANAGE_VOUCHERS,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Progress Logs',
					icon: <FaWeightScale className="nav-icon me-2" />,
					link: ROUTES.MANAGE_CHECK_INS,
					show: hasAdminPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Meal Plans',
					icon: <FaBowlFood className="nav-icon me-2" />,
					link: ROUTES.MANAGE_MEAL_PLANS,
					show: hasHelpStaffPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Meals',
					icon: <BiFoodMenu className="nav-icon me-2" />,
					link: ROUTES.MANAGE_MEALS,
					show: hasHelpStaffPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Events',
					icon: <FaCalendar className="nav-icon me-2" />,
					link: ROUTES.MANAGE_EVENTS,
					show: hasHelpStaffPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Event Sign-Ups',
					icon: <FaCalendarCheck className="nav-icon me-2" />,
					link: ROUTES.MANAGE_EVENT_CHECK_INS,
					show: hasAllStaffPermissions(authContext)
				},
			]
		},
		{
			id: uuid(),
			title: 'Raw Data Tables',
			icon: <MdTableView className="nav-icon me-2" />,
			show: (hasRepPermissions(authContext) || hasHelpStaffPermissions(authContext) || hasMarketingManagerPermissions(authContext)),
			children: [
				{
					id: uuid(),
					title: 'Leads Data',
					icon: <RiAdvertisementLine className="nav-icon me-2" />,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext),
					children: [
						{ id: uuid(), link: ROUTES.MANAGE_LEADS_RAW, name: 'Raw Leads', show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_LEADS_PENDING_RAW, name: 'Pending Leads', show: hasSuperAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_LEADS_ISSUES_RAW, name: 'Leads With Issues', show: hasSuperAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_LEADS_SUPPORT_CALL_RAW, name: 'Leads To Call', show: hasSuperAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_LEADS_SUBMITTED_RAW, name: 'Leads To Import', show: hasSuperAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_LEADS_DUPLICATES_RAW, name: 'Duplicate Leads', show: hasSuperAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_LEADS_FRAUD_RAW, name: 'Fraud Leads', show: hasSuperAdminPermissions(authContext) },
					]
				},
				{
					id: uuid(),
					title: 'Subscriptions & Orders Data',
					icon: <MdSubscriptions className="nav-icon me-2" />,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) || hasHelpStaffPermissions(authContext),
					children: [
						{ id: uuid(), link: ROUTES.MANAGE_SUBSCRIPTIONS_RAW, name: 'Raw Subscriptions', show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_CANCELLED_SUBSCRIPTIONS_RAW, name: 'Raw Cancelled Subscriptions', show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_CANCELLATION_REQUESTS_RAW, name: 'Raw Cancellation Requests', show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_ORDERS_RAW, name: 'Raw Orders', show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_ORDER_GROUPS_RAW, name: 'Raw Order Groups', show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_ENCOUNTERS_RAW, name: 'Raw Encounters', show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_PRESCRIPTIONS_RAW, name: 'Raw Prescriptions', show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_PRESCRIPTION_GROUPS_RAW, name: 'Raw Prescription Groups', show: hasRepPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_PAYMENTS_RAW, name: 'Raw Payments', show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_TRANSACTIONS_RAW, name: 'Raw Transactions', show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_VOUCHERS_RAW, name: 'Raw Vouchers', show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_CHECK_INS_RAW, name: 'Raw Progress Logs', show: hasAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_MEAL_PLANS_RAW, name: 'Raw Meal Plans', show: hasHelpStaffPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_MEALS_RAW, name: 'Raw Meals', show: hasHelpStaffPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_EVENTS_RAW, name: 'Raw Events', show: hasHelpStaffPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_EVENT_CHECK_INS_RAW, name: 'Raw Event Sign-Ups', show: hasAllStaffPermissions(authContext) },
					]
				}
			]
		},
		{
			id: uuid(),
			title: 'Community',
			icon: <RiUserCommunityFill className="nav-icon me-2" />,
			show: hasAllStaffPermissions(authContext),
			children: [
				{
					id: uuid(),
					title: 'Blog',
					icon: <FaBlog className="nav-icon me-2" />,
					children: [
						{ id: uuid(), link: ROUTES.MANAGE_ARTICLES, name: 'Articles', show: (hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) || hasHelpStaffPermissions(authContext)) },
						{ id: uuid(), link: ROUTES.MANAGE_ASSETS, name: 'Content Management', show: (hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) || hasHelpStaffPermissions(authContext)) },
						{ id: uuid(), link: ROUTES.MANAGE_ARTICLE_CATEGORIES, name: 'Article Categories', show: hasHelpStaffPermissions(authContext) },
					]
				},
				{
					id: uuid(),
					name: 'Communities',
					icon: <RiCommunityFill className="nav-icon me-2" />,
					link: ROUTES.MANAGE_COMMUNITIES,
					show: hasAllStaffPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Groups',
					icon: <MdGroup className="nav-icon me-2" />,
					link: ROUTES.MANAGE_GROUPS,
					show: hasAllStaffPermissions(authContext)
				},
				{
					id: uuid(),
					title: 'Habits',
					icon: <IoStorefrontOutline className="nav-icon me-2" />,
					children: [
						{ id: uuid(), link: ROUTES.MANAGE_HABIT_TEMPLATES, name: 'Habit Templates', show: hasHelpStaffPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_USER_HABITS, name: 'User Habits', show: hasHelpStaffPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_WALLETS, name: 'Wallets', show: hasHelpStaffPermissions(authContext) },
					]
				},
			],
		},
		{
			id: uuid(),
			title: 'Messages',
			icon: <MdOutlineMessage className="nav-icon me-2" />,
			link: ROUTES.MANAGE_MESSAGES,
			show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
		},
		{
			id: uuid(),
			title: 'Emails',
			icon: <MdEmail className="nav-icon me-2" />,
			link: ROUTES.MANAGE_EMAILS,
			show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
		},
		{
			id: uuid(),
			title: 'Reports',
			icon: <TbReport className="nav-icon me-2" />,
			link: ROUTES.MANAGE_REPORTS,
			show: hasSuperAdminPermissions(authContext)
		},
		{
			id: uuid(),
			title: 'Patients',
			icon: <PiUserRectangleLight className="nav-icon me-2" />,
			link: ROUTES.MANAGE_USERS,
			show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext)
		},
		{
			id: uuid(),
			title: 'Auth Users',
			icon: <FaUserShield className="nav-icon me-2" />,
			link: ROUTES.MANAGE_AUTH_USERS,
			show: hasSuperAdminPermissions(authContext)
		},
		{
			id: uuid(),
			title: 'Covered Entities',
			icon: <MdOutlineBusiness className="nav-icon me-2" />,
			show: hasAdminPermissions(authContext),
			children: [
				{ id: uuid(), link: ROUTES.MANAGE_COVERED_ENTITIES, name: 'Covered Entities', show: hasSuperAdminPermissions(authContext) },
				{ id: uuid(), link: ROUTES.MANAGE_COVERED_ENTITY_USERS, name: 'Covered Entity Users', show: hasAdminPermissions(authContext) },
				{ id: uuid(), link: ROUTES.MANAGE_PROVIDERS, name: 'Providers', show: hasAdminPermissions(authContext) || hasStaffManagerPermissions(authContext) },
			]
		},
		{
			id: uuid(),
			title: 'Lab Testing',
			icon: <MdBiotech className="nav-icon me-2" />,
			show: hasAdminPermissions(authContext),
			children: [
				{ id: uuid(), link: ROUTES.MANAGE_BIOMARKERS, name: 'Biomarkers', show: hasAdminPermissions(authContext) },
				{ id: uuid(), link: ROUTES.MANAGE_LAB_PANELS, name: 'Lab Panels', show: hasAdminPermissions(authContext) },
			]
		},
		{
			id: uuid(),
			title: 'Accounts Payable',
			icon: <FaFileInvoiceDollar className="nav-icon me-2" />,
			show: hasAdminPermissions(authContext),
			children: [
				{ id: uuid(), link: ROUTES.MANAGE_ACCOUNTS_PAYABLE_ORDERS, name: 'Orders Accounts Payable', show: hasAdminPermissions(authContext) },
				{ id: uuid(), link: ROUTES.MANAGE_ACCOUNTS_PAYABLE_ENCOUNTERS, name: 'Encounters Accounts Payable', show: hasAdminPermissions(authContext) },
			]
		},
		{
			id: uuid(),
			title: 'Reps',
			icon: <RiCustomerServiceFill className="nav-icon me-2" />,
			show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) || hasStaffManagerPermissions(authContext) || hasAdminPermissions(authContext),
			children: [
				{
					id: uuid(),
					name: 'Rep Dashboard Preview',
					icon: <MdDashboard className="nav-icon me-2" />,
					link: ROUTES.REP_DASHBOARD_PREVIEW,
					show: hasSuperAdminPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Manage Reps',
					icon: <FaUserNinja className="nav-icon me-2" />,
					link: ROUTES.MANAGE_REPS,
					show: hasAdminPermissions(authContext) || hasStaffManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Rep Statistics',
					icon: <GrAnalytics className="nav-icon me-2" />,
					link: ROUTES.MANAGE_REP_STATISTICS,
					show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext) || hasStaffManagerPermissions(authContext) || hasAdminPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Rep Performance',
					icon: <GrAnalytics className="nav-icon me-2" />,
					link: ROUTES.MANAGE_REP_PERFORMANCE,
					show: hasRepPerformancePermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Rep SLA',
					icon: <GrAnalytics className="nav-icon me-2" />,
					link: ROUTES.MANAGE_REP_SLA,
					show: hasRepPerformancePermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Conversions',
					icon: <RiCustomerServiceFill className="nav-icon me-2" />,
					link: ROUTES.MANAGE_REP_CONVERSIONS,
					show: hasMarketingManagerPermissions(authContext) || hasStaffManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Payouts',
					icon: <RiCustomerServiceFill className="nav-icon me-2" />,
					link: ROUTES.MANAGE_REP_PAYOUTS,
					show: hasMarketingManagerPermissions(authContext) || hasStaffManagerPermissions(authContext)
				}]
		},
		{
			id: uuid(),
			title: 'Logs',
			icon: <TbLogs className="nav-icon me-2" />,
			show: hasRepPermissions(authContext) || hasMarketingManagerPermissions(authContext),
			children: [
				{ id: uuid(), link: ROUTES.MANAGE_WEBHOOK_LOGS, name: 'Webhook Logs' },
				{ id: uuid(), link: ROUTES.MANAGE_API_LOGS, name: 'API Logs' },
				{ id: uuid(), link: ROUTES.MANAGE_CHANGELOG_LOGS, name: 'Changelog Logs' }
			]
		},
		{
			id: uuid(),
			title: 'Lab Testing',
			icon: <MdBiotech className="nav-icon me-2" />,
			show: hasSuperAdminPermissions(authContext),
			children: [
				{ id: uuid(), link: ROUTES.MANAGE_BIOMARKERS, name: 'Biomarkers', show: hasSuperAdminPermissions(authContext) },
				{ id: uuid(), link: ROUTES.MANAGE_LAB_PANELS, name: 'Lab Panels', show: hasSuperAdminPermissions(authContext) },
			]
		},
		{
			id: uuid(),
			title: 'Settings',
			icon: <MdOutlineSettings className="nav-icon me-2" />,
			show: hasAllStaffPermissions(authContext) || hasAdminPermissions(authContext) || hasStaffManagerPermissions(authContext) || hasMarketingManagerPermissions(authContext),
			children: [
				{
					id: uuid(),
					title: 'Store',
					icon: <IoStorefrontOutline className="nav-icon me-2" />,
					children: [
						{ id: uuid(), link: ROUTES.MANAGE_PRODUCTS, name: 'Products', show: hasAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_PRODUCT_CATEGORIES, name: 'Product Categories', show: hasAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_ENROLLMENT_GROUPS, name: 'Enrollment Groups', show: hasAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_PRODUCT_FAMILIES, name: 'Product Families', show: hasAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_OFFER_GROUPS, name: 'Offer Groups', show: hasAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_COMMERCIAL_EQUIVALENCY_GROUPS, name: 'Commercial Equivalency Groups', show: hasAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_FUNNEL_CHOICE_SETS, name: 'Funnel Choice Sets', show: hasAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_MEDICATION_TRANSITION_RULES, name: 'Medication Transition Rules', show: hasAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_PRODUCT_IDENTITY_AUDIT, name: 'Product Identity Audit', show: hasAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_SHIPPING_CLASSES, name: 'Shipping Classes', show: hasSuperAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_SHIPPING_METHODS, name: 'Shipping Methods', show: hasSuperAdminPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_COUPONS, name: 'Coupons', show: hasMarketingManagerPermissions(authContext) },
						{ id: uuid(), link: ROUTES.MANAGE_PROGRAMS, name: 'Programs', show: hasSuperAdminPermissions(authContext) },
					]
				},
				{
					id: uuid(),
					name: 'Reply Templates',
					icon: <MdEmail className="nav-icon me-2" />,
					link: ROUTES.MANAGE_SUPPORT_REPLY_TEMPLATES,
					show: hasAllStaffPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Snippets',
					icon: <MdOutlineMessage className="nav-icon me-2" />,
					link: ROUTES.MANAGE_SUPPORT_SNIPPETS,
					show: hasAllStaffPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Knowledge Base',
					icon: <MdMenuBook className="nav-icon me-2" />,
					link: ROUTES.MANAGE_KNOWLEDGE_BASE,
					show: hasAllStaffPermissions(authContext)
				},
				{
					id: uuid(),
					title: 'Tools',
					icon: <MdAutoFixHigh className="nav-icon me-2" />,
					children: [
						{
							id: uuid(),
							name: 'Integration Tools',
							link: ROUTES.MANAGE_INTEGRATION_TOOLS,
							show: hasAdminPermissions(authContext) || hasStaffManagerPermissions(authContext) || hasMarketingManagerPermissions(authContext)
						},
						{
							id: uuid(),
							name: 'Scheduled',
							link: ROUTES.MANAGE_SCHEDULED_FUNCTIONS,
							show: hasAdminPermissions(authContext)
						}
					]
				},
				{
					id: uuid(),
					name: 'Surveys',
					icon: <FaClipboardQuestion className="nav-icon me-2" />,
					link: ROUTES.MANAGE_SURVEYS,
					show: hasSuperAdminPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Agreements',
					icon: <FaFileSignature className="nav-icon me-2" />,
					link: ROUTES.MANAGE_AGREEMENTS,
					show: hasSuperAdminPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Email Templates',
					icon: <CgTemplate className="nav-icon me-2" />,
					link: ROUTES.MANAGE_EMAIL_TEMPLATES,
					show: hasAdminPermissions(authContext) || hasStaffManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'SMS Templates',
					icon: <TbMessage2Code className="nav-icon me-2" />,
					link: ROUTES.MANAGE_SMS_TEMPLATES,
					show: hasAdminPermissions(authContext) || hasStaffManagerPermissions(authContext)
				},
				// { id: uuid(), link: ROUTES.MANAGE_METRICS, name: 'Metrics', show: hasSuperAdminPermissions(authContext) },
				// { id: uuid(), link: ROUTES.MANAGE_CONDITIONS, name: 'Conditions', show: hasSuperAdminPermissions(authContext) },
				{
					id: uuid(),
					link: ROUTES.MANAGE_VENDORS,
					name: 'Vendors',
					show: hasSuperAdminPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Help Staff',
					icon: <MdLiveHelp className="nav-icon me-2" />,
					link: ROUTES.MANAGE_HELP_STAFF,
					show: hasAdminPermissions(authContext) || hasStaffManagerPermissions(authContext)
				},
				{
					id: uuid(),
					name: 'Admins',
					icon: <FaUserSecret className="nav-icon me-2" />,
					link: ROUTES.MANAGE_ADMINS,
					show: hasAdminPermissions(authContext)
				},
			]
		}
	];
};

export default DashboardMenu;
